__webpack_require__.p = "/uyir-kural/";